module.exports = __webpack_public_path__ + "img/gu.2a95d57a.svg";